import Vue from "vue";
import Vuex from "vuex";
import ParametersStore from "./modules/ParametersStore";
import AbsencesStore from "./modules/AbsencesStore";

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		ParametersStore,
		AbsencesStore
	}
});

if (module.hot) {
	module.hot.accept("./store.ts", () => {
		const newStore = require("./store.ts").store;
		// Remplacer l'état du store
		store.replaceState(newStore.state);
	});
}

export { store };



// WEBPACK FOOTER //
// ./src/store/store.ts